export default __webpack_public_path__ + "static/media/search.7b12eb0f.svg";